import { render, staticRenderFns } from "./OpenGridMatch.vue?vue&type=template&id=fec773ba&scoped=true"
import script from "./OpenGridMatch.vue?vue&type=script&lang=js"
export * from "./OpenGridMatch.vue?vue&type=script&lang=js"
import style0 from "./OpenGridMatch.vue?vue&type=style&index=0&id=fec773ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec773ba",
  null
  
)

export default component.exports